module.exports = __webpack_public_path__ + "static/media/school.515cf770.csv";